import { render } from "./MyPoint.vue?vue&type=template&id=64f31def&scoped=true&ts=true"
import script from "./MyPoint.vue?vue&type=script&lang=ts"
export * from "./MyPoint.vue?vue&type=script&lang=ts"

import "./MyPoint.vue?vue&type=style&index=0&id=64f31def&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f31def"]])

export default __exports__